<template>  
   <div>
    ddd
   </div>
   
   <!-- <iframe :src="nowUrl" frameborder="0"></iframe> -->
  </template>
  
  <script> 
  
  export default {
    metaInfo() {
        return {
          title: this.$route.meta.title, // 从路由获取标题
          meta: [
            { 
              name: 'keywords', 
              content: this.$route.meta.metaTags[0]['content']
            }
          ]
        }
      },
    name: 'App',
    components: {
      // HelloWorld
    },
    data(){
      return {  
        nowUrl:''
      }
    }, 
    methods: {
      // 跳转到指定页码
      goToPage(page) {
        if (page < 1 || page > this.totalPages) return;
        this.currentPage = page;
      }
    },
    mounted() {
     const id = this.$route.params.id;  // 获取路径参数 id 
     console.log(id)
      this.nowUrl = id
    }
  }
  </script>
  
  <style scoped>
  .buttonContro{
    background-color: white;
    border: 2px solid #b0c1d400;
    cursor: pointer;
    font-size: 16px;

  }
  .buttonContro:hover{
    color: #0b7bb3;

  }
  .buttonPage{
    background-color: white; 
    border: 2px solid #b0c1d400;
    cursor: pointer;
    line-height: 1;
    margin: 0 0.1rem;
    padding: 0.25rem 0.4rem;
    text-decoration: none;
    border-radius: 7px;
    font-size: 16px;
  }
  .buttonPage:hover{
    border: 2px solid #b0c1d4;

  }
  button.active {
    font-weight: bold;
    border: 2px solid #b0c1d4;
    border-radius: 7px;
  }
  button:disabled {
    color: #ccc;
  }
  .content {
    display: -webkit-box;
    -webkit-line-clamp: 2; /* 限制为2行 */
    -webkit-box-orient: vertical;
    overflow: hidden; /* 隐藏超出的内容 */
    text-overflow: ellipsis; /* 添加省略号 */
    font-size: 14px; /* 默认字体大小 */
  }
  .newContent{
     width: 500px;
     padding: 16px;
     box-shadow: -5px 0px 20px 0px rgb(73 75 77 / 10%);
     margin: 20px;

  }
  .newImg{
    height: 300px;
  }
  @media (max-width: 1029px) {
    .newContent{
      width: 100%; 

    } 
  .newImg{
    height: 100%;
  }
}
   .background-layers{
      background-image: url(../assets/images/news/news2.jpg) !important;
      background-size: 100% 100%;
      /* aspect-ratio: 468 / 294; */
      /* background-position: center bottom !important;
      background-size: cover !important;
      background-repeat: no-repeat !important; */
  } 
  </style> 